<template>
    <div>
        <a-form-model ref="CustomTemplateForm" :model="form" :rules="rules" v-bind="layout">
            <a-form-model-item
                ref="name"
                label="模板名称"
                prop="name"
                :extra="formErr.name"
                :validateStatus='!formErr.name||formErr.name==""?"":"error"'>
                <a-input
                    :maxLength=100
                    v-model="form.name"
                    @change="(e) => { formErr.name=''}"
                    @blur="(e) => {  form.name = e.target.value.trim() }"
                />
            </a-form-model-item>
            <a-form-model-item ref="theme" label="主题" prop="theme" :extra="formErr.theme"
                               :validateStatus='!formErr.theme || formErr.theme == "" ? "" : "error"'>
                <a-input type="textarea" :maxLength=200 v-model="form.theme" @change="(e) => {formErr.theme}"
                         @blur="(e) => {form.theme = e.target.value.trim()}">
                </a-input>
            </a-form-model-item>
            <a-form-model-item
                ref="content"
                label="内容"
                prop="content"
                :help="formErr.content"
                :validateStatus='!formErr.content||formErr.content==""?"":"error"'>
                <ckeditor4 ref="ckeditor" :value="contenta" :height=520 v-on:input="ckeditorContent"
                           @instanceReadyCk="instanceReadyCk" ></ckeditor4>
            </a-form-model-item>
            <a-form-model-item ref="thumb_small" label="封面图" prop="thumb_small" :help="formErr.thumb_small">
                <Myupload :url="form.thumb_small||''" @fileList="setFileList"/>
            </a-form-model-item>
            <a-form-model-item
                ref="cate_ids"
                label="模板分类"
                prop="cate_ids"
                :extra="formErr.cate_ids"
                :validateStatus='!formErr.cate_ids||formErr.cate_ids==""?"":"error"'>
                <a-checkbox-group v-model="form.cate_ids">
                    <a-checkbox :value="item.id" v-for="item in this.seleList.cate"> {{ item.name }}</a-checkbox>
                </a-checkbox-group>
            </a-form-model-item>
            <a-form-model-item
                ref="group_id"
                label="模板分组"
                prop="group_id"
                :extra="formErr.group_id"
                :validateStatus='!formErr.group_id||formErr.group_id==""?"":"error"'>
                <a-radio-group v-model="form.group_id">
                  <a-radio :value="item.id" v-for="item in this.seleList.group"> {{ item.name }}</a-radio>
                </a-radio-group>
            </a-form-model-item>
            <a-form-model-item
                ref="status"
                label="状态"
                prop="status"
                :extra="formErr.status"
                :validateStatus='!formErr.status||formErr.status==""?"":"error"'>
                <a-radio-group v-model="form.status">
                    <a-radio :value="item.value" v-for="item in this.seleList.show_status"> {{ item.name }}</a-radio>
                </a-radio-group>
            </a-form-model-item>
        </a-form-model>
        <div style="text-align:center">
            <a-button :style="{ marginRight: '8px' }" type="primary" @click="onSubmit">
                确定
            </a-button>
            <a-button @click="onCancel">
                取消
            </a-button>
        </div>
    </div>
</template>
<script>
import ckeditor4 from '../../../Components/ckeditors';
import {submitForm} from "@/utils/utils";
import Myupload from '../../../Components/my-upload/index.vue'
import API from "../api";

export default {
    components: {ckeditor4, Myupload},
    data() {
        return {
            id: this.$route.query.id,
            contenta: "",
            form: {
                name: "",
                theme: "",
                content: "",
                status: 1,
                thumb_small: "",
                cate_ids: [],
                group_id:""
            },
            formErr: {
                name: "",
                content: "",
                cate_ids: "",
                group_id:""
            },
            rules: {
                name: [{required: true, message: "请输入模板名称 ", trigger: "blur"}, {
                    whitespace: true,
                    message: "请输入模板名称 "
                }],
                content: [{required: true, message: "请输入内容 ", trigger: "blur"}, {
                    whitespace: true,
                    message: "请输入内容 "
                }],
                cate_ids: [{required: true, message: "请选择模板分类",}],
                group_id:[{required: true, message: "请选择模板分组 "}]
            },
            layout: {
                labelCol: {span: 3},
                wrapperCol: {span: 18},
            },
            seleList: [],
        };
    },
    methods: {
        ckeditorContent(val) {
            this.form.content = val
        },
        instanceReadyCk(type) {
            if (type == true) {
                let _that = this
                this.$nextTick().then(function () {
                    if (_that.id != undefined) {
                        _that.editform(_that.id)
                    }
                })
            }
        },
        // 提交表单
        onSubmit() {
            let _this = this;
            this.$refs.ckeditor.$emit("getText")
            this.$refs.CustomTemplateForm.validate(valid => {
                let url
                if (valid) {
                    this.form.id == '' || this.form.id == undefined ? url = API.ACustomTemplate.SUBMIT_ADD : url = API.ACustomTemplate.SUBMIT_EDIT
                    submitForm(url, _this.form).then(res => {
                        if (res == true) {
                            this.$router.push({path: "/CustomTemplate/CustomTemplateList"});
                        } else {
                            res.map((item) => {
                                this.formErr[item.field] = item.msg
                            })
                        }
                    })
                } else {
                    console.log('false')
                    return false;
                }
            });
        },
        // 取消按钮
        onCancel() {
            this.$router.go(-1)
        },
        // 获取 编辑数据
        editform() {
            API.ACustomTemplate.EDIT_DATA({id: this.id}).then(res => {
                let data = res.data.data.info
                data.cate_ids = data.cate_ids.split(",").length > 1 ? data.cate_ids.split(",").map(Number) : [data.cate_ids].map(Number)
                this.form = data
                let _that = this
                this.$nextTick().then(function () {
                    // setTimeout(() => {
                    _that.contenta = data.content_text
                    // }, 300)
                })
                this.form.id = data.id
                this.cate_ids = data.cate_ids
            })
        },
        setFileList(url) {
            this.form.thumb_small = url
        },
        getFormData() {
            API.ACustomTemplate.ADD_DATA().then(res => {
                this.seleList = res.data.data
            })
        },
    },
    created() {
        this.$store.state.adminleftnavnum = "/CustomTemplate/CustomTemplateList"; //设置左侧导航2-2 active
    },
    mounted() {
        this.getFormData();
    },
}
</script>
<style scoped>
.ant-form-item-children {
    min-height: 1500px;
}
</style>
